import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'

import session from './session'
import menu from './menu'

import loader from './loader'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  modules: {
    auth,
    session,
    menu,
    loader
  }
})
